if (!customElements.get('product-gallery-swiper')) {
  customElements.define(
    'product-gallery-swiper',
    class ProductGallerySwiper extends HTMLElement {
      connectedCallback() {
        this.pendingMediaId = null;
        this.onResize = this.syncThumbsHeight.bind(this);
        this.initWhenSwiperReady();
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        this.resizeObserver?.disconnect();
        this.destroySwipers();
      }

      initWhenSwiperReady() {
        if (typeof Swiper !== 'undefined') {
          this.initSwipers();
          return;
        }

        const interval = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(interval);
            this.initSwipers();
          }
        }, 50);

        setTimeout(() => clearInterval(interval), 5000);
      }

      destroySwipers() {
        if (this.mainSwiper && typeof this.mainSwiper.destroy === 'function') {
          this.mainSwiper.destroy(true, true);
        }
        if (this.thumbsSwiper && typeof this.thumbsSwiper.destroy === 'function') {
          this.thumbsSwiper.destroy(true, true);
        }
        this.mainSwiper = null;
        this.thumbsSwiper = null;
      }

      initSwipers() {
        const mainEl = this.querySelector('[data-pdp-main]');
        if (!mainEl || typeof Swiper === 'undefined') return;

        this.destroySwipers();

        const thumbsEl = this.querySelector('[data-pdp-thumbs]');
        const thumbsCol = this.querySelector('.pdp-gallery__thumbs');
        const thumbsNextEl = this.querySelector('[data-pdp-thumbs-next]');
        const prevEl = this.querySelector('[data-pdp-prev]');
        const nextEl = this.querySelector('[data-pdp-next]');
        const paginationEl = this.querySelector('[data-pdp-pagination]');
        const initialIndex = Number(this.dataset.initialIndex || 0);

        this.thumbsEl = thumbsEl;
        this.thumbsCol = thumbsCol;
        this.thumbsNextEl = thumbsNextEl;
        this.mainEl = mainEl;

        if (thumbsEl) {
          this.thumbsSwiper = new Swiper(thumbsEl, {
            direction: 'vertical',
            slidesPerView: 'auto',
            spaceBetween: 16,
            watchSlidesProgress: true,
            watchOverflow: true,
            slideToClickedSlide: true,
            rewind: true,
            navigation: thumbsNextEl
              ? {
                  nextEl: thumbsNextEl,
                }
              : undefined,
          });
        }

        this.mainSwiper = new Swiper(mainEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 400,
          initialSlide: initialIndex,
          watchOverflow: true,
          rewind: true,
          observer: true,
          observeParents: true,
          pagination: paginationEl
            ? {
                el: paginationEl,
                clickable: true,
              }
            : undefined,
          navigation: {
            nextEl: nextEl || null,
            prevEl: prevEl || null,
          },
          thumbs: this.thumbsSwiper
            ? {
                swiper: this.thumbsSwiper,
              }
            : undefined,
          on: {
            slideChange: () => this.onSlideChange(),
          },
        });

        this.resizeObserver?.disconnect();
        if (typeof ResizeObserver !== 'undefined' && mainEl) {
          this.resizeObserver = new ResizeObserver(() => this.syncThumbsHeight());
          this.resizeObserver.observe(mainEl);
        }

        mainEl.querySelectorAll('img').forEach((img) => {
          if (!img.complete) {
            img.addEventListener('load', () => this.syncThumbsHeight(), { once: true });
          }
        });

        this.syncThumbsHeight();

        if (this.pendingMediaId) {
          this.goToMedia(this.pendingMediaId);
        }
      }

      syncThumbsHeight() {
        if (!this.thumbsCol || !this.mainEl) return;
        if (window.matchMedia('(max-width: 749px)').matches) {
          this.thumbsCol.style.height = '';
          if (this.thumbsEl) this.thumbsEl.style.height = '';
          return;
        }

        const mainHeight = this.mainEl.offsetHeight;
        if (!mainHeight) return;

        this.thumbsCol.style.height = `${mainHeight}px`;
        if (this.thumbsEl) {
          this.thumbsEl.style.height = `${mainHeight}px`;
        }
        this.thumbsSwiper?.update();
      }

      setActiveMedia(mediaId) {
        this.pendingMediaId = mediaId;
        this.goToMedia(mediaId);
      }

      goToMedia(mediaId) {
        if (!this.mainSwiper || !mediaId) return;

        const index = Array.from(this.mainSwiper.slides).findIndex(
          (slide) => slide.dataset.mediaId === String(mediaId)
        );
        if (index < 0) return;

        this.mainSwiper.slideTo(index);
      }

      onSlideChange() {
        if (!this.mainSwiper) return;

        const activeSlide = this.mainSwiper.slides[this.mainSwiper.activeIndex];
        if (!activeSlide) return;

        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        const deferredMedia = activeSlide.querySelector('deferred-media, product-model');
        if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent(false);
        }
      }
    }
  );
}
